const isIPhoneX = (() => {
  const isIphone = /iphone/gi.test(window.navigator.userAgent)
  const pixelRatio = window.devicePixelRatio
  const { width, height } = window.screen
  const isIPhoneX =
    isIphone &&
    pixelRatio &&
    pixelRatio === 3 &&
    width === 375 &&
    height === 812
  const isIPhoneXSMax =
    isIphone &&
    pixelRatio &&
    pixelRatio === 3 &&
    width === 414 &&
    height === 896
  const isIPhoneXR =
    isIphone &&
    pixelRatio &&
    pixelRatio === 2 &&
    width === 414 &&
    height === 896
  // const paddingBottom = isIPhoneX || isIPhoneXSMax || isIPhoneXR
  // return paddingBottom ? '30px' : '0'
  return isIPhoneX || isIPhoneXSMax || isIPhoneXR
})()

export function getWebEnv() {
  const ua = navigator.userAgent
  let BrowserInfo = {
    isPhone: !!/(iPhone|iPad|iPod|iOS|Android)/i.test(ua),
    isWeixin: !!ua.match(/MicroMessenger/gi),
    isMiniProgram: !!ua.match(/miniProgram/gi),
    isAli: !!ua.match(/AlipayClient/gi),
    isAndroid: !!ua.match(/android/gi),
    isIphone: !!ua.match(/iphone|ipod/gi),
    isIpad: !!ua.match(/ipad|Macintosh/gi),
    isIOS: !!ua.match(/iphone|ipod|ipad|Macintosh/gi),
    isIPhoneX
  }
  return BrowserInfo
}